import { schema } from "normalizr";

export const documentTemplate = new schema.Entity("documentTemplate");
export const documentTemplates = [documentTemplate];
